import ChatFeedView from './ChatFeedView';

export default ChatFeedView;
